<template>
  <div class="text-base md:text-lg">
    <!-- HERO -->
    <HeroBlog :page="page" />

    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <!-- LEAD -->
    <div
      v-if="page.lead"
      class="pt-10 sm:pt-12 md:pt-14 lg:pt-16 xl:pt-20"
      :class="{
        'pb-10 sm:pb-12 md:pb-14 lg:pb-16 xl:pb-20':
          Array.isArray(page.components) && page.components.length === 0,
      }"
    >
      <Container indent="container-default sm:container-tighter">
        <div
          class="flex flex-wrap flex-col sm:flex-row gap-[0.6rem] sm:gap-8 leading-tight md:leading-snug pb-7 text-2xs tracking-wider md:gap-16 sm:pb-9"
        >
          <p>
            Autor
            <span class="font-bold tracking-normal">{{ page.author }}</span>
          </p>
          <p>
            Datum
            <span class="font-bold tracking-normal">{{ page.blog_date }}</span>
          </p>
        </div>
      </Container>
      <LeadText :lead="page.lead" />
    </div>

    <!-- COMPONENT LOADER -->
    <ComponentsLoader v-if="page.components" :components="page.components" />

    <!-- BLOG SLIDER -->
    <ContentBlogSlider v-if="page.show_blog_slider" :data="blogSliderData" />
  </div>
</template>

<script setup>
import { useTitle } from '@vueuse/core'

const props = defineProps({
  page: { type: Object, required: true },
})

const blogSliderData = computed(() => {
  return {
    heading: props.page.slider_heading,
    load_automatically: props.page.slider_load_automatically,
    amount_blog_posts: props.page.slider_amount_blog_posts,
    blog_posts: props.page.slider_blog_posts,
    button_text: props.page.slider_button_text,
    button_link: props.page.slider_button_link,
  }
})

const title = useTitle()
let breadcrumbs = [
  {
    url: '/blog',
    title: 'Blog',
    blueprint: null,
  },
  {
    url: null,
    title: title.value,
    blueprint: 'section',
  },
]
</script>
